/* ============================================================
   VALOX Theme JS
   ============================================================ */
(function () {
  'use strict';

  const VALOX = window.VALOX || {};
  window.VALOX = VALOX;

  /* ---------- Helpers ---------- */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  const formatMoney = (cents) => {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    const value = (cents / 100).toFixed(2);
    return '$' + value;
  };

  /* ---------- Sticky / Scroll header ---------- */
  function initHeaderScroll() {
    const header = $('.site-header');
    if (!header) return;
    let lastY = window.scrollY;
    const handle = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      lastY = y;
    };
    handle();
    window.addEventListener('scroll', handle, { passive: true });
  }

  /* ---------- Mobile drawer ---------- */
  function initMobileDrawer() {
    const toggle = $('.header-mobile-toggle');
    const drawer = $('.mobile-drawer');
    const close = $('.mobile-drawer-close');
    const overlay = $('.mobile-drawer-overlay');
    if (!toggle || !drawer) return;

    const open = () => {
      drawer.classList.add('is-open');
      document.body.classList.add('is-menu-open');
      document.body.style.overflow = 'hidden';
    };
    const closeFn = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('is-menu-open');
      document.body.style.overflow = '';
    };
    toggle.addEventListener('click', open);
    close && close.addEventListener('click', closeFn);
    overlay && overlay.addEventListener('click', closeFn);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeFn();
    });
  }

  /* ---------- Cart drawer ---------- */
  const CartDrawer = {
    el: null,
    open() {
      if (!this.el) this.el = $('.cart-drawer');
      if (!this.el) return;
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close() {
      if (!this.el) this.el = $('.cart-drawer');
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    init() {
      this.el = $('.cart-drawer');
      $$('[data-cart-open]').forEach((b) => {
        b.addEventListener('click', (e) => {
          if (b.tagName === 'A' && b.getAttribute('href') === '/cart' && !b.dataset.forceDrawer) {
            // allow normal navigation only if not configured for drawer
          }
          e.preventDefault();
          this.open();
        });
      });
      if (this.el) this.bindLineEvents();
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.el && this.el.classList.contains('is-open')) this.close();
      });
    },
    async refresh() {
      try {
        const [sectionRes, cartRes] = await Promise.all([
          fetch('/cart?sections=cart-drawer', { credentials: 'same-origin' }),
          fetch('/cart.js', { credentials: 'same-origin' }),
        ]);
        const [json, cart] = await Promise.all([sectionRes.json(), cartRes.json()]);
        if (json && json['cart-drawer']) {
          const target = $('.cart-drawer');
          if (target) {
            const tmp = document.createElement('div');
            tmp.innerHTML = json['cart-drawer'].trim();
            const next = tmp.querySelector('.cart-drawer');
            if (next) {
              target.innerHTML = next.innerHTML;
              this.bindLineEvents();
            }
          }
        }
        $$('.cart-count').forEach((el) => {
          el.dataset.count = cart.item_count;
          el.textContent = cart.item_count;
        });
      } catch (e) {
        console.warn('Cart refresh failed', e);
      }
    },
    bindLineEvents() {
      const drawer = $('.cart-drawer');
      if (!drawer) return;
      $$('.cart-line-qty button', drawer).forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          const action = btn.dataset.qty;
          const key = btn.dataset.key;
          const input = btn.parentElement.querySelector('input');
          const current = parseInt(input.value || '0', 10);
          const next = action === 'inc' ? current + 1 : Math.max(0, current - 1);
          await this.updateLine(key, next);
        });
      });
      $$('.cart-line-remove', drawer).forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          await this.updateLine(btn.dataset.key, 0);
        });
      });
      const close = $('.cart-drawer-close', drawer);
      const overlay = $('.cart-drawer-overlay', drawer);
      close && close.addEventListener('click', () => this.close());
      overlay && overlay.addEventListener('click', () => this.close());
    },
    async updateLine(key, qty) {
      const drawer = $('.cart-drawer');
      if (drawer) {
        const anchor = drawer.querySelector(`[data-key="${key}"]`);
        const line = anchor && anchor.closest('.cart-line');
        if (qty === 0 && line) {
          line.remove();
          if (!drawer.querySelector('.cart-line')) this.renderEmptyState(drawer);
        } else if (line) {
          const input = line.querySelector('.cart-line-qty input');
          if (input) input.value = qty;
        }
      }
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: qty })
        });
        this.refresh();
      } catch (e) {
        console.warn(e);
        this.refresh();
      }
    },
    showAddingSkeleton() {
      const drawer = $('.cart-drawer');
      if (!drawer) return;
      const empty = drawer.querySelector('.cart-empty');
      if (!empty) return;
      const body = drawer.querySelector('.cart-drawer-body');
      if (!body) return;
      const block = 'background:var(--color-grey-light);border-radius:4px;';
      body.innerHTML = `
        <div class="cart-line" aria-hidden="true" style="opacity:.7;">
          <div class="cart-line-img" style="${block}"></div>
          <div class="cart-line-body">
            <div style="${block}height:14px;width:85%;"></div>
            <div style="${block}height:14px;width:60%;margin-top:6px;"></div>
            <div style="${block}height:28px;width:120px;margin-top:12px;border-radius:999px;"></div>
          </div>
          <div style="${block}height:18px;width:60px;"></div>
        </div>
      `;
    },
    renderEmptyState(drawer) {
      const headCount = drawer.querySelector('.cart-drawer-head h3 span');
      if (headCount) headCount.textContent = '(0)';
      const bar = drawer.querySelector('.cart-shipping-bar');
      if (bar) bar.remove();
      const foot = drawer.querySelector('.cart-drawer-foot');
      if (foot) foot.remove();
      const body = drawer.querySelector('.cart-drawer-body');
      if (body) {
        body.innerHTML = `
          <div class="cart-empty">
            <div class="cart-empty-icon"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 7H19L17.5 21H6.5L5 7Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M9 10V7C9 4.79086 10.3431 3 12 3C13.6569 3 15 4.79086 15 7V10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></div>
            <h3>ตะกร้าของคุณว่างเปล่า</h3>
            <p>เริ่มต้นกิจวัตรดูแลชุดกีฬาของคุณ เลือกสินค้าเพื่อเริ่มดูแลชุดอย่างมืออาชีพ</p>
            <a href="/collections/all" class="btn btn-primary" style="margin-top:16px">เลือกซื้อสินค้า <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>
          </div>
        `;
      }
      $$('.cart-count').forEach((el) => {
        el.dataset.count = '0';
        el.textContent = '0';
      });
    },
  };

  /* ---------- Quick add ---------- */
  async function quickAdd(form, button) {
    const formData = new FormData(form);
    button && button.classList.add('is-loading');
    CartDrawer.showAddingSkeleton();
    CartDrawer.open();
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript' },
        credentials: 'same-origin',
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        showToast('Added to cart');
        CartDrawer.refresh();
      } else {
        showToast(data.description || 'Could not add to cart', true);
      }
    } catch (e) {
      showToast('Could not add to cart', true);
    } finally {
      button && button.classList.remove('is-loading');
    }
  }

  function initQuickAdd() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      const form = btn.closest('form') || $(`form[data-product-id="${btn.dataset.productId}"]`);
      if (!form) return;
      quickAdd(form, btn);
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function showToast(message, isError) {
    let toast = $('#toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'toast';
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.background = isError ? 'var(--color-red)' : 'var(--color-navy)';
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2400);
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    $$('.accordion-trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.accordion-item');
        if (!item) return;
        item.classList.toggle('is-open');
      });
    });
  }

  /* ---------- Product page (variant + media) ---------- */
  function initProductMedia() {
    $$('.product-media-thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.mediaId;
        const main = $('.product-media-main img');
        if (main && id) {
          main.src = thumb.dataset.mediaSrc || thumb.querySelector('img').src;
          main.srcset = thumb.dataset.mediaSrcset || '';
        }
        $$('.product-media-thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  function initVariantSelector(form) {
    if (!form) return;
    const productData = form.querySelector('[data-product-json]');
    if (!productData) return;
    let product;
    try {
      product = JSON.parse(productData.textContent);
    } catch { return; }
    const inputs = $$('.product-option-value input', form);
    const variantInput = form.querySelector('[name="id"]');
    const priceEl = $('[data-product-price]');
    const compareEl = $('[data-product-compare]');
    const submitEl = form.querySelector('[type="submit"]');

    const applyVariant = () => {
      const selectedOptions = [];
      $$('.product-option', form).forEach((optEl) => {
        const checked = optEl.querySelector('input:checked');
        if (checked) selectedOptions.push(checked.value);
      });
      const variant = product.variants.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
      if (!variant) return;
      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitEl) {
        if (variant.available) {
          submitEl.disabled = false;
          submitEl.textContent = submitEl.dataset.addText || 'Add to cart';
        } else {
          submitEl.disabled = true;
          submitEl.textContent = submitEl.dataset.soldText || 'Sold out';
        }
      }
      // update URL
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };

    inputs.forEach((input) => input.addEventListener('change', applyVariant));
    applyVariant();
  }

  function initProductForm() {
    const form = $('.product-form');
    if (!form) return;
    initVariantSelector(form);

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const submit = form.querySelector('[type="submit"]');
      submit && submit.classList.add('is-loading');
      CartDrawer.showAddingSkeleton();
      CartDrawer.open();
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript' },
          credentials: 'same-origin',
          body: fd,
        });
        const data = await res.json();
        if (res.ok) {
          showToast('Added to cart');
          CartDrawer.refresh();
        } else {
          showToast(data.description || 'Could not add to cart', true);
        }
      } catch {
        showToast('Could not add to cart', true);
      } finally {
        submit && submit.classList.remove('is-loading');
      }
    });

    // Quantity
    $$('.qty-btn', form).forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = form.querySelector('.qty-input');
        if (!input) return;
        let val = parseInt(input.value || '1', 10);
        val = btn.dataset.qty === 'inc' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });
  }

  /* ---------- Newsletter ---------- */
  function initNewsletter() {
    $$('form.footer-newsletter, form.newsletter-form').forEach((form) => {
      form.addEventListener('submit', (e) => {
        // Let Shopify handle, but show toast
        setTimeout(() => showToast('Thanks for subscribing!'), 200);
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    const els = $$('.fade-up, .fade-in, [data-stagger]');
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach((el) => obs.observe(el));
  }

  /* ---------- Cart page (if used) ---------- */
  function initCartPage() {
    const cartForm = $('form[action="/cart"]');
    if (!cartForm) return;
    $$('[data-cart-qty]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        const action = btn.dataset.cartQty;
        const key = btn.dataset.key;
        const input = btn.parentElement.querySelector('input');
        const next = action === 'inc' ? parseInt(input.value, 10) + 1 : Math.max(0, parseInt(input.value, 10) - 1);
        input.value = next;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: next })
        });
        location.reload();
      });
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initHeaderScroll();
    initMobileDrawer();
    CartDrawer.init();
    initQuickAdd();
    initAccordion();
    initProductMedia();
    initProductForm();
    initNewsletter();
    initReveal();
    initCartPage();
  });

  VALOX.CartDrawer = CartDrawer;
  VALOX.showToast = showToast;
})();
